export default ({ request }) => ({
  resFabricDemandDetailListApi(data = {}) {
    return request({
      url: '/digitalCenter/res/fabric/demand/detail/list',
      method: 'post',
      data
    })
  },

})
